import { X } from 'lucide-react';
import { useMapStore } from '../../stores/mapStore';

export function OutOfRegionBanner() {
  const message = useMapStore((s) => s.outOfRegionMessage);
  const dismissOutOfRegionBanner = useMapStore((s) => s.dismissOutOfRegionBanner);

  if (!message) return null;

  return (
    <div
      data-testid="out-of-region-banner"
      className="px-4 py-2.5 text-sm font-medium shadow-md bg-amber-500 text-white dark:bg-amber-600"
      role="status"
    >
      <div className="flex items-start gap-3 max-w-3xl mx-auto">
        <p className="flex-1 text-center leading-snug">{message}</p>
        <button
          type="button"
          onClick={dismissOutOfRegionBanner}
          className="flex-shrink-0 p-1 rounded-md hover:bg-white/15 transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
